import {
  ChangeDetectorRef,
  ComponentFactoryResolver,
  ComponentRef,
  Directive,
  ElementRef,
  Input,
  OnDestroy,
  OnInit,
  TemplateRef,
  ViewContainerRef
} from '@angular/core';

import { TooltipComponent } from './tooltip.component';
import { TooltipOptions } from './tooltip.model';


@Directive({
  selector: '[cpTooltip]'
})
export class TooltipDirective implements OnInit, OnDestroy {
  @Input()
  cpTooltip: TemplateRef<any>;

  @Input()
  data: any;

  @Input()
  tooltipEnabled = true;

  isHovering = false;
  tooltip: ComponentRef<TooltipComponent> | undefined;

  private tooltipOptions: TooltipOptions;

  constructor(
    public elementRef: ElementRef,
    private cd: ChangeDetectorRef,
    private viewContainer: ViewContainerRef,
    private cfr: ComponentFactoryResolver) {
  }

  ngOnInit() {
    if (!this.tooltipEnabled) {
      return;
    }

    const element = this.elementRef.nativeElement as HTMLElement;
    element.addEventListener('mouseenter', this.onMouseOver);
    element.addEventListener('mouseleave', this.onMouseOut);

    this.tooltipOptions = {
      position: 'top',
      hoverDelay: 500,
      margin: 0,
      popupClass: ''
    };
  }

  ngOnDestroy() {
    if (!this.tooltipEnabled) {
      return;
    }

    const element = this.elementRef.nativeElement as HTMLElement;
    element.removeEventListener('mouseenter', this.onMouseOver);
    element.removeEventListener('mouseleave', this.onMouseOut);
  }

  onMouseOver = () => {
    this.isHovering = true;
    if (!this.tooltip) {
      setTimeout(() => {
        if (this.isHovering && !this.tooltip) {
          this.showTooltip();
        }
      }, this.tooltipOptions.hoverDelay);
    }
  }

  onMouseOut = () => {
    this.isHovering = false;
    if (this.tooltip) {
      this.hideTooltip();
    }
  }

  private showTooltip() {
    if (!this.cpTooltip) {
      return;
    }

    const tooltipContentFactory = this.cfr.resolveComponentFactory(TooltipComponent);
    this.tooltip = this.viewContainer.createComponent(tooltipContentFactory);
    this.tooltip.instance.data = this.data;
    this.tooltip.instance.content = this.cpTooltip;
    this.tooltip.instance.parent = this.elementRef;
    this.tooltip.instance.options = this.tooltipOptions;
    this.cd.markForCheck();
  }

  private hideTooltip() {
    if (this.tooltip) {
      this.tooltip.destroy();
    }
    this.tooltip = undefined;
  }
}
